// --------------------------------------------------------------
// Created On: 2025-08-20
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./SuccessBanner.module.scss";

// Success message.
export default function SuccessBanner(props: Props): Component {
  return props.message.length > 0 ? (
    <div data-test="success-banner" className={`${styles.body} alert alert-success`} role="alert">
      <div>{props.message}</div>
      {props.children !== undefined && props.children}
    </div>
  ) : null;
}

interface Props {
  message: string;
  children?: Children;
}
